export default {
    androidInteractiveQuestionHeaders:
        "android_interactive_question_headers_v1",
    personalise_config_v1: "personalise_config_v1",
};
